"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      modelId: '', //产品型号id
      searchData: {
        time: '',
        page: 1,
        rows: 10 },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      showAdd: false, //是否显示新增弹窗
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        } },

      tableData: [],
      tableColumns: [
      {
        prop: 'centerLowestVersion',
        label: '中心板最低版本号' },

      {
        prop: 'command',
        label: '程序指令' },

      {
        prop: 'popStartTime',
        label: '弹窗时间段',
        formatter: function formatter(row, column, cellValue, index) {
          return "".concat(row.popStartTime, "\u2014").concat(row.popEndTime);
        } },

      {
        prop: 'content',
        label: '弹窗文案' },

      {
        prop: 'displayEndTime',
        label: '首页展示时间段',
        formatter: function formatter(row, column, cellValue, index) {
          return "".concat(row.popStartTime, "\u2014").concat(row.displayEndTime);
        } },

      {
        prop: 'createTime',
        label: '创建时间' },

      {
        prop: 'releaseTag',
        label: '是否发布',
        formatter: function formatter(row, column, cellValue, index) {
          return row.releaseTag ? '是' : '否';
        } }],


      recForm: {
        id: '',
        centerLowestVersion: '',
        command: '',
        time: '',
        content: '',
        releaseTag: '',
        displayEndTime: '' },
      //推荐表单
      recFormRule: {
        centerLowestVersion: [{
          required: true,
          message: '请填写中心板最低版本',
          trigger: ['blur', 'change'] }],

        command: [{
          required: true,
          message: '请选择程序指令',
          trigger: ['blur', 'change'] }],

        time: [{
          required: true,
          message: '请选择弹窗时间段',
          trigger: ['blur', 'change'] }],

        content: [{
          required: true,
          message: '请填写弹窗文案',
          trigger: ['blur', 'change'] }],

        releaseTag: [{
          required: true,
          message: '请选择是否发布',
          trigger: ['blur', 'change'] }],

        displayEndTime: [{
          required: true,
          message: '请选择首页展示结束时间',
          trigger: ['blur', 'change'] }] },


      centerList: [], //中心板版本列表
      editRow: '' //当前编辑项
    };
  },

  mounted: function mounted() {
    this.modelId = this.$route.params.modelId;
    this.initPage();
  },

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchList();
      this.fetchCenterList();
    },

    /**
        * 获取列表
        */
    fetchList: function fetchList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      if (params.time) {
        params.popStartTime = params.time[0] + ' 00:00:00';
        params.popEndTime = params.time[1] + ' 23:59:59';
      }
      delete params['time'];
      params.typeCodeId = this.modelId;
      this.getData('/api/seasonalProgram', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取中心板版本
        */
    fetchCenterList: function fetchCenterList() {var _this2 = this;
      this.getData('/api/versionInfo', { firmwareType: 1, page: 1, rows: 999999999 }, function (res) {
        _this2.centerList = res.list;
      });
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchList();
    },

    /**
        * 查询
        */
    onClickSearch: function onClickSearch() {
      this.$set(this.searchData, 'page', 1);
      this.fetchList();
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'time', '');
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', 10);
      this.fetchList();
    },

    /**
        * 编辑
        */
    updateItem: function updateItem(row) {
      this.editRow = Object.assign({}, row);
      this.showAdd = true;
      this.$set(this.recForm, 'id', row.id);
      this.$set(this.recForm, 'centerLowestVersion', row.centerLowestVersion);
      this.$set(this.recForm, 'command', row.command);
      this.$set(this.recForm, 'time', [row.popStartTime, row.popEndTime]);
      this.$set(this.recForm, 'content', row.content);
      this.$set(this.recForm, 'releaseTag', row.releaseTag);
      this.$set(this.recForm, 'displayEndTime', row.displayEndTime);

      this.pickerOptions = {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date(row.popStartTime).getTime() - 24 * 3600 * 1000;
        } };

    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this3 = this;
      this.$confirm('您确定要删除该配置吗？删除后该配置将失效并且删除历史记录。', '删除', { type: 'warning' }).then(function (res) {
        //删除版本
        _this3.delData("/api/seasonalProgram/deleteById/".concat(row.id), {}, function (res) {
          _this3.fetchList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 下架
        */
    offItem: function offItem(row) {var _this4 = this;
      if (row.releaseTag) {
        this.$confirm('您确定要下架该配置吗？下架后该配置将失效。', '下架', { type: 'warning' }).then(function (res) {
          //下架
          _this4.getData("/api/seasonalProgram/delistingByid/".concat(row.id), {}, function (res) {
            _this4.fetchList();
          });
        }).catch(function (err) {

        });
      } else {
        this.$confirm('您确定要发布该配置吗？发布后该配置将生效上架。', '发布', { type: 'warning' }).then(function (res) {
          //发布
          _this4.getData("/api/seasonalProgram/releaseByid/".concat(row.id), {}, function (res) {
            _this4.fetchList();
          });
        }).catch(function (err) {

        });
      }
    },

    /**
        * 弹窗时间段-change
        */
    onTimeChange: function onTimeChange(event) {
      this.$set(this.recForm, 'displayEndTime', '');
      if (event) {
        this.pickerOptions = {
          disabledDate: function disabledDate(time) {
            return time.getTime() < new Date(event[0]).getTime() - 24 * 3600 * 1000;
          } };

      }
    },

    /**
        * 新增
        */
    onSubmitRec: function onSubmitRec() {var _this5 = this;
      this.$refs.versionForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this5.recForm);
          params.popStartTime = params.time[0];
          params.popEndTime = params.time[1];
          params.typeCodeId = _this5.modelId;
          delete params['time'];
          if (params.id) {
            //编辑
            params.createTime = _this5.editRow.createTime;
            params.delFlag = _this5.editRow.delFlag;
            _this5.putData('/api/seasonalProgram', params, function (res) {
              _this5.onDialogClose();
              _this5.fetchList();
            });
          } else {
            //新增
            delete params['id'];
            _this5.postData('/api/seasonalProgram', params, function (res) {
              _this5.onDialogClose();
              _this5.fetchList();
            });
          }
        }
      });
    },

    /**
        * 弹窗关闭
        */
    onDialogClose: function onDialogClose() {var _this6 = this;
      this.$nextTick(function () {
        Object.keys(_this6.recForm).forEach(function (key) {
          _this6.$set(_this6.recForm, key, '');
        });
        _this6.$refs.recForm.clearValidate();
      });
      this.showAdd = false;
    } } };exports.default = _default;